export default __webpack_public_path__ + "static/media/logo-3.f73ca9ff.webp";